import { render, staticRenderFns } from "./ProductSection.vue?vue&type=template&id=4316d846&scoped=true"
import script from "./ProductSection.vue?vue&type=script&lang=js"
export * from "./ProductSection.vue?vue&type=script&lang=js"
import style0 from "./ProductSection.vue?vue&type=style&index=0&id=4316d846&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4316d846",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4316d846')) {
      api.createRecord('4316d846', component.options)
    } else {
      api.reload('4316d846', component.options)
    }
    module.hot.accept("./ProductSection.vue?vue&type=template&id=4316d846&scoped=true", function () {
      api.rerender('4316d846', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/svg-editor/ProductSection.vue"
export default component.exports